<template>
  <div class="flex-box">
    <div class="search-box">
      <div>
        <label class="searchItemName">账号：</label>
        <el-input class="input-box" placeholder="登录账号" v-model="queryParams.account" clearable
          @keyup.enter.native="search()"></el-input>
      </div>
      <div>
        <label class="searchItemName">渠道：</label>
        <el-select v-model="queryParams.channelId" clearable placeholder="筛选渠道">
          <el-option v-for="item in channels" :key="item.id" :label="item.channelName" :value="item.id"></el-option>
        </el-select>
      </div>
      <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="search()">查询</el-button>
      <el-button type="success" icon="el-icon-plus" @click="openDialog()">新建帐户</el-button>
    </div>
    <el-table :data="tableData" border style="width: 100%; margin: 15px 0;">
      <el-table-column prop="account" label="账号" width="130" align="center"></el-table-column>
      <el-table-column prop="name" label="姓名" width="120" align="center"></el-table-column>
      <el-table-column label="角色" width="130" align="center">
        <template slot-scope="scope">{{ ROLE_NAMES[scope.row.role] || scope.row.roleName || scope.row.role }}</template>
      </el-table-column>
      <el-table-column label="渠道" width="160" align="center">
        <template slot-scope="scope">{{ scope.row.channelName || '—' }}</template>
      </el-table-column>
      <el-table-column label="状态" width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="statusType(scope.row.status)">{{ statusText(scope.row.status) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="loginLimit" label="登录时段" width="140" align="center"></el-table-column>
      <el-table-column label="有效期" width="170" align="center">
        <template slot-scope="scope">{{ formatDate(scope.row.expireDate) }}</template>
      </el-table-column>
      <el-table-column label="最近登录" width="170" align="center">
        <template slot-scope="scope">{{ formatDate(scope.row.loginTime) }}</template>
      </el-table-column>
      <el-table-column prop="loginIp" label="登录IP" width="130" align="center"></el-table-column>
      <el-table-column label="操作" width="380" align="center">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" plain @click="openDialog(scope.row)">编辑</el-button>
          <el-button type="warning" size="mini" plain @click="resetPassword(scope.row)">重置密码</el-button>
          <el-button v-if="scope.row.status === 1 || scope.row.status === -3" type="info" size="mini" plain @click="operate(scope.row, 216, '禁用')">禁用</el-button>
          <el-button v-if="scope.row.status === 0" type="success" size="mini" plain @click="operate(scope.row, 204, '激活')">激活</el-button>
          <el-button v-if="scope.row.status === -2" type="success" size="mini" plain @click="operate(scope.row, 205, '解锁')">解锁</el-button>
          <el-button type="danger" size="mini" plain @click="remove(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="queryParams.pageIndex" :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next" :total="total">
    </el-pagination>
    <el-dialog :title="form.id ? '编辑帐户' : '新建帐户'" :visible.sync="dialogVisible" width="520px">
      <el-form :model="form" label-width="110px">
        <el-form-item label="账号">
          <el-input v-model="form.account" :disabled="!!form.id" placeholder="登录账号"></el-input>
        </el-form-item>
        <el-form-item v-if="!form.id" label="密码">
          <el-input v-model="form.password" show-password placeholder="字母+数字+特殊符号，至少8位"></el-input>
        </el-form-item>
        <el-form-item label="姓名"><el-input v-model="form.name" placeholder="真实姓名"></el-input></el-form-item>
        <el-form-item label="角色">
          <el-select v-model="form.role" style="width: 100%;" @change="onRoleChange">
            <el-option v-for="item in roleOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="needChannel" label="渠道">
          <el-select v-model="form.channelId" :disabled="!!form.id" placeholder="请选择渠道" style="width: 100%;">
            <el-option v-for="item in channels" :key="item.id" :label="item.channelName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="登录开始">
          <el-time-picker v-model="form.loginBeginTime" format="HH:mm" value-format="HH:mm" placeholder="00:00" style="width: 100%;"></el-time-picker>
        </el-form-item>
        <el-form-item label="登录结束">
          <el-time-picker v-model="form.loginEndTime" format="HH:mm" value-format="HH:mm" placeholder="23:59" style="width: 100%;"></el-time-picker>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="save()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import listPage from '../../../mixins/listPage.js'
import { post } from '../../../../public/request/request.js'
import { ROLE_NAMES } from '../../../mock/index.js'

const PWD_PATTERN = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*,.?;:_=+-]).{8,}$/

export default {
  mixins: [listPage],
  data() {
    return {
      ROLE_NAMES,
      channels: [],
      total: 0,
      queryParams: { pageIndex: 1, pageSize: 10, account: '', channelId: '' },
      tableData: [],
      dialogVisible: false,
      form: {}
    }
  },
  computed: {
    roleOptions() {
      return Object.keys(ROLE_NAMES)
        .map(id => ({ id: Number(id), name: ROLE_NAMES[id] }))
        .filter(item => item.id > 0)
    },
    needChannel() {
      return Number(this.form.role) !== 1
    }
  },
  created() {
    this.loadChannels()
    this.GetData()
  },
  methods: {
    statusText(status) {
      if (status === 1) return '正常'
      if (status === 0) return '禁用'
      if (status === -2) return '锁定'
      if (status === -3) return '待改密'
      return '未知'
    },
    statusType(status) {
      if (status === 1) return 'success'
      if (status === 0) return 'info'
      if (status === -3) return 'warning'
      return 'danger'
    },
    parseLoginRange(loginLimit) {
      if (!loginLimit || String(loginLimit).indexOf('-') < 0) {
        return { loginBeginTime: '00:00', loginEndTime: '23:59' }
      }
      const parts = String(loginLimit).split('-').map(s => s.trim())
      return {
        loginBeginTime: parts[0] || '00:00',
        loginEndTime: parts[1] || '23:59'
      }
    },
    formatDate(value) {
      if (!value) return ''
      const text = String(value)
      if (text.indexOf('1900-01-01') === 0 || text.indexOf('0001-01-01') === 0) return ''
      return text
    },
    search() {
      this.queryParams.pageIndex = 1
      this.GetData()
    },
    loadChannels() {
      post(208, { channelName: '' }).then(response => {
        if (response.data.result == 0 && Array.isArray(response.data.data)) {
          this.channels = response.data.data
        }
      }).catch(() => {})
    },
    GetData() {
      const loading = this.openLoading()
      post(203, {
        pageIndex: this.queryParams.pageIndex,
        pageSize: this.queryParams.pageSize,
        account: (this.queryParams.account || '').trim(),
        channelId: this.queryParams.channelId || 0
      }).then(response => {
        loading.close()
        if (response.data.result == 0) {
          const data = response.data.data || {}
          this.tableData = Array.isArray(data.list) ? data.list : []
          this.total = Number(data.pageCount) || 0
        } else {
          this.tableData = []
          this.total = 0
          this.$message.error('查询失败：' + response.data.message)
        }
      }).catch(error => {
        loading.close()
        this.tableData = []
        this.total = 0
        this.$message.error((error && error.userMessage) || '查询失败')
      })
    },
    openDialog(row) {
      if (row) {
        const range = this.parseLoginRange(row.loginLimit)
        this.form = {
          id: row.id,
          account: row.account,
          name: row.name,
          role: row.role,
          channelId: row.channelId,
          loginBeginTime: range.loginBeginTime,
          loginEndTime: range.loginEndTime
        }
      } else {
        this.form = {
          account: '',
          password: '',
          name: '',
          role: 1,
          channelId: '',
          loginBeginTime: '00:00',
          loginEndTime: '23:59'
        }
      }
      this.dialogVisible = true
    },
    onRoleChange() {
      if (!this.needChannel) {
        this.form.channelId = ''
      }
    },
    save() {
      const account = (this.form.account || '').trim()
      const name = (this.form.name || '').trim()
      if (!account) {
        this.$message.error('账号不能为空')
        return
      }
      if (!name) {
        this.$message.error('姓名不能为空')
        return
      }
      if (!this.form.role) {
        this.$message.error('请选择角色')
        return
      }

      const isEdit = !!this.form.id
      if (!isEdit) {
        if (!this.form.password) {
          this.$message.error('密码不能为空')
          return
        }
        if (!PWD_PATTERN.test(this.form.password)) {
          this.$message.error('密码至少包含英文字符、数字及特殊符号，长度不小于8位')
          return
        }
        if (this.needChannel && !this.form.channelId) {
          this.$message.error('请选择渠道')
          return
        }
      }

      const loginBeginTime = this.form.loginBeginTime || '00:00'
      const loginEndTime = this.form.loginEndTime || '23:59'
      if (loginEndTime <= loginBeginTime) {
        this.$message.error('登录结束时间必须大于开始时间')
        return
      }
      const loading = this.openLoading()
      const req = isEdit
        ? post(221, {
          id: this.form.id,
          name,
          role: this.form.role,
          loginBeginTime,
          loginEndTime
        })
        : post(202, {
          account,
          password: this.form.password,
          name,
          role: this.form.role,
          channelId: this.needChannel ? this.form.channelId : 0,
          loginBeginTime,
          loginEndTime
        })

      req.then(response => {
        loading.close()
        if (response.data.result == 0) {
          this.$message.success(isEdit ? '修改成功' : '注册成功')
          this.dialogVisible = false
          this.GetData()
        } else {
          this.$message.error((isEdit ? '修改失败：' : '注册失败：') + response.data.message)
        }
      }).catch(error => {
        loading.close()
        this.$message.error((error && error.userMessage) || (isEdit ? '修改失败' : '注册失败'))
      })
    },
    resetPassword(row) {
      this.$confirm(`确认重置帐户「${row.account}」的密码吗？`, '提示', {
        type: 'warning',
        confirmButtonText: '重置',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.openLoading()
        post(206, { objId: row.id }).then(response => {
          loading.close()
          if (response.data.result == 0) {
            this.$alert(response.data.message || '重置成功', '重置密码成功', { confirmButtonText: '确定' })
            this.GetData()
          } else {
            this.$message.error('重置密码失败：' + response.data.message)
          }
        }).catch(error => {
          loading.close()
          this.$message.error((error && error.userMessage) || '重置密码失败')
        })
      }).catch(() => {})
    },
    operate(row, api, action) {
      this.$confirm(`确认${action}帐户「${row.account}」吗？`, '提示', {
        type: 'warning',
        confirmButtonText: action,
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.openLoading()
        post(api, { objId: row.id }).then(response => {
          loading.close()
          if (response.data.result == 0) {
            this.$message.success(response.data.message || `${action}成功`)
            this.GetData()
          } else {
            this.$message.error(`${action}失败：` + response.data.message)
          }
        }).catch(error => {
          loading.close()
          this.$message.error((error && error.userMessage) || `${action}失败`)
        })
      }).catch(() => {})
    },
    remove(row) {
      this.$confirm(`确认删除帐户「${row.account}」吗？`, '提示', {
        type: 'warning',
        confirmButtonText: '删除',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.openLoading()
        post(207, { objId: row.id }).then(response => {
          loading.close()
          if (response.data.result == 0) {
            this.$message.success('删除成功')
            if (this.tableData.length === 1 && this.queryParams.pageIndex > 1) {
              this.queryParams.pageIndex -= 1
            }
            this.GetData()
          } else {
            this.$message.error('删除失败：' + response.data.message)
          }
        }).catch(error => {
          loading.close()
          this.$message.error((error && error.userMessage) || '删除失败')
        })
      }).catch(() => {})
    }
  }
}
</script>
